export default "__VITE_ASSET__Dzu_7$F3__"